import { parse } from "query-string";
import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import "./style.css";
async function toDataURL(url) {
    const blob = await fetch(url).then((res) => res.blob());
    return URL.createObjectURL(blob);
}
export async function download(url, imgName) {
    const a = document.createElement("a");
    a.href = await toDataURL(url);
    a.download = imgName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
export default function DownloadableFileItem(props) {
    const { key, orderId } = parse(location.search);
    const { ref, inView } = useInView({
        rootMargin: "100px",
        triggerOnce: true,
    });
    const [url, setUrl] = useState(undefined);
    useEffect(() => {
        if (inView === false)
            return;
        setUrl(`/api/public/users/order/${orderId}/downloadable/${props.file.imageId}?key=${key}`);
    }, [inView]);
    return (React.createElement("div", { ref: ref, className: "downloadable-file-item" },
        React.createElement("img", { src: url }),
        React.createElement("div", { className: "download-button-container" },
            React.createElement(Button, { text: "", value: "download-file", onClick: async () => {
                    await download(url, props.file.name);
                } },
                React.createElement("img", { src: "/assets/icons/download-file-icon.svg", width: "24" })))));
}
